import * as React from 'react';

import { Portal } from 'react-portal';
import styled from 'styled-components';

import { COLOR, FONT_SIZE } from '../../packages/constants';
import { LoadingSpinner } from '../loading-spinner';

export interface LoadingScreenProps {
    message?: string;
}

const StyledLoadingScreen = styled.div`
    position: sticky;
    top: 25vh;
    margin-top: 20px;
    margin-bottom: 12px;
    display: flex;
    background: #fff;
    border-radius: 5px;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08), 0 2.2px 1.7px -10px rgba(0, 0, 0, 0.08),
        0 5.3px 4px -10px rgba(0, 0, 0, 0.06), 0 10px 7.5px -10px rgba(0, 0, 0, 0.06),
        0 17.9px 13.4px -10px rgba(0, 0, 0, 0.05), 0 33.4px 25.1px -10px rgba(0, 0, 0, 0.04),
        0 80px 60px -10px rgba(0, 0, 0, 0.04);
    padding: 10px;
    padding-right: 16px; // temporary to balance because the spinner adds 6px left margin
    font-size: bu(2);
    height: fit-content;
    line-height: normal;
`;

const Overlay = styled.div`
    background-color: ${COLOR.MODAL.MODAL_OVERLAY};
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    z-index: 9999;
`;

const StyledLoadingSpinner = styled(LoadingSpinner)`
    margin-right: 10px;
`;

const StyledMessage = styled.p`
    display: block;
    flex-grow: 1;
    text-align: center;
    font-weight: bold;
    font-size: ${FONT_SIZE.MEDIUM};
    color: ${COLOR.PRIMARY.BLACK};
`;

export const LoadingScreen = React.forwardRef<HTMLDivElement, LoadingScreenProps>(
    ({ message = 'Loading...', ...props }, ref) => (
        <Portal node={document.body}>
            <Overlay>
                <StyledLoadingScreen ref={ref} {...props}>
                    <StyledLoadingSpinner color="black" />
                    <StyledMessage>{message}</StyledMessage>
                </StyledLoadingScreen>
            </Overlay>
        </Portal>
    ),
);
LoadingScreen.displayName = 'LoadingScreen';
